import { useCallback } from 'react'

import { useNavigate } from 'Pods/Shared/ContextBasedRouter'
import { STUDIO_PATH } from 'Pods/ThreeDStudio/constants'
import useRequireLogin from 'Pods/ThreeDStudio/Hooks/useRequireLogin'
import { openFullImageEditor } from 'Pods/ThreeDStudio/Store/actions/ui'

// Opens a community image in the full image editor, like the library's Edit image. The
// editor only renders on the Image Generator route, so the gallery navigates there and
// flags the navigation so the editor survives it. No runId: the run belongs to another
// user, so the editor's Delete must stay disabled.
function useImageEdit() {
  const navigate = useNavigate()
  const requireLogin = useRequireLogin('login')

  return useCallback((image) => {
    if (!image.assetId || !requireLogin()) return

    openFullImageEditor({ image: { id: image.assetId, url: image.src, alt: image.title } })
    navigate(STUDIO_PATH.IMAGE_GENERATOR, { state: { keepImageEditor: true } })
  }, [navigate, requireLogin])
}

export default useImageEdit
